import { supabase } from "@/integrations/supabase/client"

export const uploadHeroImageToEvent = async (
  imageData: string,
  eventId: string,
  eventType: string = 'festival',
  category: string = 'hero'
) => {
  try {
    const { data, error } = await supabase.functions.invoke('upload-hero-image', {
      body: {
        imageData,
        eventId,
        eventType,
        category
      }
    })

    if (error) throw error

    return data
  } catch (error) {
    console.error('Error uploading hero image:', error)
    throw error
  }
}
